import { ILayoutOptions } from "models/layout";
import Basket from "components/basket/Basket";
import LanguagePicker from "components/ui/language/LanguagePicker";
import Smiley from "components/ui/smiley/Smiley";

import "./Topbar.scss";

interface ITopbarProps extends Partial<ILayoutOptions> {
  clickHandlers: {
    sidebar: () => void;
    logo: () => void;
    basket: () => void;
    continue: () => void;
  };
}

export default function Topbar(props: ITopbarProps) {
  const { hideSidebar, hideBasket, clickHandlers } = props;

  return (
    <nav className="header">
      <div className="inner">
        <div className="header-section mobile-sidebar-trigger">
          {!hideSidebar && (
            <button className="mobile-sidebar-button" onClick={clickHandlers.sidebar}>
              ☰
            </button>
          )}
        </div>

        <div className="header-section minicart-section">
          <Smiley />

          <LanguagePicker />
          
          {!hideBasket && <Basket isMini isClosing handleContinue={clickHandlers.continue} handleBasketToggle={clickHandlers.basket} />}
        </div>
      </div>
    </nav>
  );
}
